import { isEqualWith, isPlainObject } from 'es-toolkit/predicate';
export default function areDocumentInputsEqual(first, second) {
    return isEqualWith(first, second, (a, b) => {
        if ((Array.isArray(a) && Array.isArray(b)) || (isPlainObject(a) && isPlainObject(b))) {
            return;
        }
        // Binary data, workers and range transports represent distinct resources.
        return Object.is(a, b);
    });
}
